import React from 'react'
import './home.css'
import Landing from './Landing'
import Description from './Description'
import EventsHome from './eventsHome'

export default function Home(){
  return (
    <div>
        <Landing />
        <Description />
        <EventsHome />
    </div>
  )
}